// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_2020_REGIONS_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_2020_REGIONS_LOADED() {
      return {
        isLoading: false,
        regions: action.micRegions
      };
    },
    MIC_2020_REGIONS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSector.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
